// signin.js
import './signin.css';

// --- Firebase Imports ---
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import {
    getAuth,
    onAuthStateChanged,
    signInWithEmailAndPassword,
    // ======================================================================
    //   REMOVED FOR GOOGLE AUTH INDEPENDENCE
    //   Description: Commented out Firebase modules for Google-specific auth.
    // ======================================================================
    // GoogleAuthProvider,
    // signInWithPopup
} from 'firebase/auth';
import {
    getFirestore,
    doc,
    getDoc,
    setDoc,
    serverTimestamp
} from 'firebase/firestore';

// --- Firebase Configuration ---
const firebaseConfig = {
    apiKey: process.env.FIREBASE_API_KEY,
    authDomain: process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.FIREBASE_APP_ID,
    measurementId: process.env.FIREBASE_MEASUREMENT_ID
};

// --- Initialize Firebase ---
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
if (firebaseConfig.measurementId) {
    getAnalytics(app);
}

// --- Main Initialization ---
function main() {
    setupAuthentication(auth, db);
    setupTypingAnimation();

    onAuthStateChanged(auth, (user) => {
        if (user) {
            console.log("User is signed in. Redirecting...");
            setTimeout(() => { window.location.replace('app.html'); }, 250);
        }
    });
}

// --- Authentication Setup ---
function setupAuthentication(auth, db) {
    const emailInput = document.getElementById('email');
    const passwordInput = document.getElementById('password');
    const signInBtn = document.getElementById('signInBtn');
    const errorMessageDiv = document.getElementById('error-message');
    
    // ======================================================================
    //   REMOVED FOR GOOGLE AUTH INDEPENDENCE
    //   Description: Element selectors for the Google sign-in/sign-up buttons
    //   are no longer needed and have been commented out.
    // ======================================================================
    // const googleSignInBtn = document.getElementById('googleSignInBtn'); // On the sign-in form
    // const googleSignUpBtn = document.getElementById('googleSignUpBtn'); // On the sign-up form
    
    // Updated the critical element check to remove the Google buttons.
    if (!emailInput || !signInBtn || !errorMessageDiv) {
        console.error("Critical form element is missing. Aborting setup authentication.");
        return;
    }

    const displayError = (message) => { errorMessageDiv.textContent = message; };
    const clearError = () => { errorMessageDiv.textContent = ''; };

    // --- Email & Password Sign-In ---
    signInBtn.addEventListener('click', (e) => {
        e.preventDefault();
        clearError();
        const email = emailInput.value;
        const password = passwordInput.value;
        if (!email || !password) {
            displayError("Email and password are required.");
            return;
        }

        signInWithEmailAndPassword(auth, email, password)
            .catch(error => {
                if (error.code === 'auth/invalid-email' || error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
                    displayError("Incorrect email or password.");
                } else {
                    displayError("An error occurred: " + error.message);
                }
            });
    });

    // ======================================================================
    //   REMOVED FOR GOOGLE AUTH INDEPENDENCE
    //   Description: The entire event listener for the Google Sign-In button
    //   has been commented out as the button is no longer in the HTML.
    // ======================================================================
    /*
    googleSignInBtn.addEventListener('click', () => {
        clearError();
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider)
            .then(async (result) => {
                const user = result.user;
                const userRef = doc(db, "users", user.uid);
                const docSnap = await getDoc(userRef);

                if (docSnap.exists()) {
                    console.log('Existing Google user signed in:', user.displayName);
                    window.location.replace('app.html');
                } else {
                    console.log('New Google user detected. Transitioning to subscription form.');
                    if (window.showSignupForm) {
                        window.showSignupForm({
                            name: user.displayName,
                            email: user.email,
                            message: "Welcome! It looks like you're new here. Please choose a plan to complete your sign-up."
                        });
                    } else {
                        console.error('showSignupForm function not found.');
                        displayError('Please complete your registration below.');
                    }
                }
            })
            .catch(handleGoogleAuthError);
    });
    */
    
    // ======================================================================
    //   REMOVED FOR GOOGLE AUTH INDEPENDENCE
    //   Description: The entire event listener for the Google Sign-Up button
    //   has been commented out as the button is no longer in the HTML.
    // ======================================================================
    /*
    if (googleSignUpBtn) {
        googleSignUpBtn.addEventListener('click', () => {
            clearError();
            const provider = new GoogleAuthProvider();
            signInWithPopup(auth, provider)
                .then((result) => {
                    const user = result.user;
                    const nameInput = document.getElementById('cus-name');
                    const emailInput = document.getElementById('cus-email');
                    
                    if (nameInput) nameInput.value = user.displayName;
                    if (emailInput) emailInput.value = user.email;

                    console.log('Subscription form pre-filled with Google data.');
                })
                .catch(handleGoogleAuthError);
        });
    }
    */
}

// ======================================================================
//   REMOVED FOR GOOGLE AUTH INDEPENDENCE
//   Description: This error handling function was specific to Google
//   authentication and is no longer needed.
// ======================================================================
/*
function handleGoogleAuthError(error) {
    const errorMessageDiv = document.getElementById('error-message');
    const displayError = (message) => { if (errorMessageDiv) errorMessageDiv.textContent = message; };

    if (error.code === 'auth/popup-closed-by-user') {
        console.log('Google sign-in cancelled by user.');
    } else {
        console.error('Google sign-in error details:', error);
        displayError("Failed to sign in with Google. Please try again.");
    }
}
*/

// --- Typing Animation (No changes) ---
function setupTypingAnimation() {
    const typingElement = document.querySelector('.typing');
    if (!typingElement) return;
    const commands = ["M can join your online meetings as an AI scribe...", "M can transform a voice memo into a structured document...", "M can translate a phone conversation in real-time...", "M can analyze your journal entries for mood patterns...", "M can scan emails to automatically create to-do items...", "M can act as a live sounding board for complex ideas...", "M can draft a blog post from a simple prompt...", "M can enrich your contacts with current job titles...", "M can generate an image of 'a robot meditating'...", "M can provide live, on-screen guidance during a call...", "M can offer personalized prompts for daily journaling...", "M can decompose a large project into smaller sub-tasks...", "M can learn your communication style to draft messages...", "M can summarize a 50-page PDF into key bullet points...", "M can analyze sentiment in your text conversations...", "M can help you practice and rehearse a presentation...", "M can create a pre-meeting brief on any contact...", "M can place phone calls to any number in the world...", "M can watch and summarize a video you upload...", "M can prioritize your daily tasks based on your goals...", "M can translate text messages to chat with anyone...", "M can listen to a debrief and create a to-do list...", "M can research a company and summarize its key people...","M can brainstorm creative ideas by playing devil's advocate...", "M can align all suggestions with your core principles...", "M can extract all names and addresses from a document...","M can schedule high-priority tasks in your calendar...","M can transcribe and email a meeting summary to attendees...","M can identify different speakers in an audio file...","M can execute a workflow: from idea, to to-do, to email..."];
    let cmdIndex = 0, charIndex = 0;
    const type = () => { if (charIndex < commands[cmdIndex].length) { typingElement.textContent += commands[cmdIndex].charAt(charIndex++); setTimeout(type, 50); } else { setTimeout(erase, 2000); } };
    const erase = () => { if (charIndex > 0) { typingElement.textContent = commands[cmdIndex].substring(0, --charIndex); setTimeout(erase, 25); } else { cmdIndex = (cmdIndex + 1) % commands.length; setTimeout(type, 500); } };
    setTimeout(type, 1500);
}

// --- Run on DOM Load ---
document.addEventListener('DOMContentLoaded', main);